// Temporary text obfuscation logic needed for Demo Mode.
// TODO: Remove this file when Golang services start handling data obfuscation

export function replaceLastName(lastName: string): string {
  const firstChar: string = lastName.trim().charAt(0).toLowerCase();

  switch (firstChar) {
  case 'a':
    return 'Smith';
  case 'b':
    return 'Johnson';
  case 'c':
    return 'Williams';
  case 'd':
    return 'Brown';
  case 'e':
    return 'Jones';
  case 'f':
    return 'Garcia';
  case 'g':
    return 'Miller';
  case 'h':
    return 'Davis';
  case 'i':
    return 'Sanchez';
  case 'j':
    return 'Ramirez';
  case 'k':
    return 'Lee';
  case 'l':
    return 'Rivera';
  case 'm':
    return 'Perez';
  case 'n':
    return 'Smith';
  case 'o':
    return 'Johnson';
  case 'p':
    return 'Williams';
  case 'q':
    return 'Brown';
  case 'r':
    return 'Jones';
  case 's':
    return 'Garcia';
  case 't':
    return 'Miller';
  case 'u':
    return 'Davis';
  case 'v':
    return 'Sanchez';
  case 'w':
    return 'Ramirez';
  case 'x':
    return 'Lee';
  case 'y':
    return 'Rivera';
  case 'z':
    return 'Perez';
  default:
    return 'Lewis';
  }
}
